import {SIZE} from '@/utils/constants/globalStyle'
import {Tag as PeacockTag} from 'pepsico-ds'
/**
 * Tag component renders a tag with specified properties.
 *
 * @param {Object} props - The properties object.
 * @param {string | import('react').ReactNode} props.text - The text to be displayed inside the tag.
 * @param {boolean} [props.isRemovable=false] - Whether the tag is removable.
 * @param {boolean} [props.isCopyable=false] - Whether the text is copyable.
 * @param {('default'|'gray'|'green'|'red'|'orange'|'blue')} [props.color='green'] - The color of the tag.
 * @param {string} [props.id=''] - Optional additional id to apply to the tag.
 * @param {import('react').MouseEventHandler<HTMLSpanElement>} [props.onRemove] - Function to handle remove events.
 * @param {('large'|'small')} [props.size='large'] - The size of the tag.
 * @param {('default'|'faded'|'outlined')} [props.type='default'] - The visual type of the tag.
 * @param {string} [props.iconLeading] - Leading icon name rendered before the label.
 * @param {(e: React.MouseEvent<HTMLSpanElement>) => void} [props.onClick] - Click handler.
 * @param {boolean} [props.disabled=false] - Whether the tag is disabled.
 * @param {boolean} [props.skeleton=false] - Whether to show a skeleton/loading state.
 * @param {string} [props.className] - Optional additional className to apply to the tag.
 * @returns {JSX.Element} The rendered Tag component.
 */

const Tag = ({
  text,
  isRemovable = false,
  isCopyable = false,
  color = 'green',
  onRemove,
  id,
  size = SIZE.LARGE,
  type = 'default',
  iconLeading,
  onClick,
  disabled = false,
  skeleton = false,
  className,
}) => {
  return (
    <PeacockTag
      id={`tag` + (id ? `_${id}` : '')}
      data-testid={`tag` + (id ? `_${id}` : '')}
      text={text}
      isCopyable={isCopyable}
      color={color}
      isRemovable={isRemovable}
      onRemove={onRemove}
      size={size}
      type={type}
      iconLeading={iconLeading}
      onClick={onClick}
      disabled={disabled}
      skeleton={skeleton}
      className={className}
    />
  )
}

export default Tag
